/* everstory-upload.js — real photo upload for the product + landing forms.
   Each [data-er-upload] block uploads images straight from the browser to a
   Cloudinary UNSIGNED preset (no secret exposed), then writes the returned
   secure_url into hidden properties[_Photo N] inputs inside the surrounding
   <form>, so the photos travel with the order as line-item properties. The
   leading underscore keeps the long URLs out of the cart + checkout (merchant
   still sees them on the admin order); the customer sees a "Photos uploaded"
   count instead.

   The photo cap follows the selected reel:
     - product page: reads data-maxphotos off the checked variant radio
       (First Look 3 / Keepsake 10 / Heirloom 20 / Legacy 40) and updates live.
     - landing (free First Look): fixed at data-maxfixed.

   If data-cloud / data-preset are not set, the block degrades to a decorative
   "upload opens after checkout" state and add-to-cart still works.
   Re-inits on shopify:section:load (theme editor). See ADR-005. */
(function () {
  var MAX_BYTES = 10 * 1024 * 1024; // 10MB per photo (Cloudinary free-tier image cap)

  function cloudUrl(cloud) {
    return 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/upload';
  }

  function initUpload(block) {
    if (block.dataset.erUploadReady) return;
    block.dataset.erUploadReady = '1';

    var cloud = (block.dataset.cloud || '').trim();
    var preset = (block.dataset.preset || '').trim();
    var configured = cloud && preset;

    var form = block.closest('form');
    var grid = block.querySelector('[data-up-grid]');
    var input = block.querySelector('[data-up-input]');
    var moreBtn = block.querySelector('[data-up-more]');
    var errEl = block.querySelector('[data-up-err]');
    var note = block.querySelector('[data-up-note]');
    var fallback = block.querySelector('[data-up-fallback]');
    var label = block.querySelector('[data-up-label]');
    var minPhotos = parseInt(block.dataset.min || '0', 10);
    var fixedMax = parseInt(block.dataset.maxfixed || '0', 10);
    var submitBtn = form ? form.querySelector('[data-add-btn], button[name="add"]') : null;
    var baseSlots = grid ? grid.querySelectorAll('[data-up-slot]').length : 0;

    if (!configured || !grid || !input) {
      if (note) note.hidden = true;
      if (fallback) fallback.hidden = false;
      if (moreBtn) moreBtn.hidden = true;
      return;
    }
    if (fallback) fallback.hidden = true;

    var pendingSlot = null; // slot awaiting the file dialog result

    function slots() { return Array.prototype.slice.call(grid.querySelectorAll('[data-up-slot]')); }
    function isFilled(s) { return s.classList.contains('is-done') || s.classList.contains('is-loading'); }
    function doneCount() { return slots().filter(function (s) { return s.classList.contains('is-done'); }).length; }
    function usedCount() { return slots().filter(isFilled).length; }
    function firstEmpty() { return slots().filter(function (s) { return !isFilled(s); })[0] || null; }
    function showErr(msg) { if (errEl) { errEl.textContent = msg || ''; errEl.style.display = msg ? 'block' : 'none'; } }

    function maxPhotos() {
      if (fixedMax > 0) return fixedMax;
      var r = form && form.querySelector('[data-variant-radio]:checked');
      var m = r && parseInt(r.dataset.maxphotos, 10);
      return (m && m > 0) ? m : 99;
    }

    // Rebuild the properties[_Photo N] hidden inputs from the uploaded slots, in
    // DOM order, contiguous 1..k — so removals never leave gaps or stale names.
    // The leading underscore makes each photo URL a *hidden* line-item property:
    // it never shows in the cart or Shopify's hosted checkout (where the raw
    // Cloudinary URL would otherwise be a huge eyesore), but the merchant still
    // sees every _Photo N URL on the admin order. The visible count the customer
    // sees is the separate "Photos uploaded" property below.
    function renumber() {
      if (!form) return;
      Array.prototype.slice.call(form.querySelectorAll('input[data-up-prop]')).forEach(function (i) { i.remove(); });
      var n = 0;
      slots().forEach(function (s) {
        if (s.classList.contains('is-done') && s.dataset.url) {
          n++;
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'properties[_Photo ' + n + ']';
          h.value = s.dataset.url;
          h.setAttribute('data-up-prop', '');
          form.appendChild(h);
        }
      });
    }

    function syncState() {
      var n = doneCount(), max = maxPhotos();
      if (label) label.textContent = minPhotos > 0
        ? 'Add ' + minPhotos + ' photos to get started'
        : 'Add your photos (up to ' + max + ')';
      if (form) {
        var hid = form.querySelector('input[name="properties[Photos uploaded]"]');
        if (!hid) { hid = document.createElement('input'); hid.type = 'hidden'; hid.name = 'properties[Photos uploaded]'; form.appendChild(hid); }
        hid.value = String(n);
      }
      if (moreBtn) moreBtn.hidden = !(firstEmpty() === null && slots().length < max);
      if (minPhotos > 0 && submitBtn) submitBtn.disabled = n < minPhotos;
    }

    function makeSlot() {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'repl__upslot';
      s.setAttribute('data-up-slot', '');
      s.textContent = '+';
      bindSlot(s);
      grid.appendChild(s);
      return s;
    }

    function clearSlot(slot) {
      delete slot.dataset.url;
      var idx = slots().indexOf(slot);
      if (idx >= baseSlots) {
        slot.remove(); // an "add more" slot — drop it entirely
      } else {
        slot.classList.remove('is-done', 'is-loading');
        slot.innerHTML = '+';
      }
      renumber();
      syncState();
    }

    // Put a slot into its finished state from a URL that is already on Cloudinary. Used by the
    // upload's own success path and by the First Look handoff below, so the two cannot drift.
    function markDone(slot, url, previewEl) {
      slot.classList.remove('is-loading');
      slot.classList.add('is-done');
      slot.dataset.url = url;
      if (!previewEl) {
        slot.innerHTML = '';
        previewEl = document.createElement('img');
        previewEl.src = url;
        previewEl.alt = '';
        slot.appendChild(previewEl);
      }
      var x = document.createElement('span');
      x.className = 'repl__upx';
      x.setAttribute('role', 'button');
      x.setAttribute('tabindex', '0');
      x.setAttribute('aria-label', 'Remove photo');
      x.innerHTML = '&times;';
      x.addEventListener('click', function (ev) { ev.stopPropagation(); clearSlot(slot); });
      x.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); ev.stopPropagation(); clearSlot(slot); } });
      slot.appendChild(x);
      renumber();
      syncState();
    }

    // The First Look handoff. A reader who filled the tray in a Journal article (initFirstLook()
    // in everstory-reskin.js) arrives here with their Cloudinary URLs in sessionStorage; adopting
    // them means the product page never asks for the same files a second time. The key is cleared
    // straight after so a later visit starts clean, and anything malformed is ignored rather than
    // thrown, because a bad stash must not break the buy box.
    function adoptFirstLook() {
      var urls;
      try {
        urls = JSON.parse(sessionStorage.getItem('er_firstlook') || '[]');
        sessionStorage.removeItem('er_firstlook');
      } catch (e) { return; }
      if (!Array.isArray(urls) || !urls.length) return;
      urls.filter(function (u) { return typeof u === 'string' && /^https:\/\//.test(u); })
        .slice(0, maxPhotos())
        .forEach(function (url) {
          var slot = firstEmpty() || (slots().length < maxPhotos() ? makeSlot() : null);
          if (slot) markDone(slot, url);
        });
    }

    function fillSlot(slot, file) {
      showErr('');
      if (file.size > MAX_BYTES) { showErr('Each photo must be under 10MB.'); return; }
      if (!/^image\//.test(file.type)) { showErr('Please choose image files only.'); return; }

      slot.classList.remove('is-done');
      slot.classList.add('is-loading');
      slot.innerHTML = '';
      var prog = document.createElement('span');
      prog.className = 'repl__upprog';
      slot.appendChild(prog);
      var preview = document.createElement('img');
      try { preview.src = URL.createObjectURL(file); } catch (e) {}
      slot.appendChild(preview);

      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', preset);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', cloudUrl(cloud), true);
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) prog.style.width = Math.round((e.loaded / e.total) * 92) + '%';
      };
      xhr.onload = function () {
        slot.classList.remove('is-loading');
        var ok = xhr.status >= 200 && xhr.status < 300, url = '';
        if (ok) { try { url = JSON.parse(xhr.responseText).secure_url || ''; } catch (e) {} }
        if (!ok || !url) { showErr('Upload failed. Please try that photo again.'); clearSlot(slot); return; }
        prog.remove();
        markDone(slot, url, preview);
        // The cookieless half of the same fact (ADR-019). everstory-hit.js can see the picker open;
        // only this callback knows a photograph reached Cloudinary, and that is the event read as
        // intent. Once per session there, so it counts visitors rather than photographs.
        if (window.esHit) window.esHit('upload_done');
        try {
          var rr = form && form.querySelector('[data-variant-radio]:checked');
          var detail = {
            count: doneCount(),
            max: maxPhotos(),
            tier: rr ? (rr.dataset.cta || '').replace(/&rarr;|→/g, '').trim() : 'First Look'
          };
          // everstory-reskin.js owns the one forwarder (Shopify analytics plus Meta).
          if (window.EverstoryTrack) {
            window.EverstoryTrack('everstory_photo_upload', detail);
          } else if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('everstory_photo_upload', detail);
          }
        } catch (e) {}
      };
      xhr.onerror = function () { slot.classList.remove('is-loading'); showErr('Upload failed. Check your connection and try again.'); clearSlot(slot); };
      xhr.send(fd);
    }

    function handleFiles(files) {
      var list = Array.prototype.slice.call(files), max = maxPhotos();
      list.forEach(function (file) {
        if (usedCount() >= max) { showErr('Your selected reel includes ' + max + ' photos.'); pendingSlot = null; return; }
        var slot = pendingSlot || firstEmpty() || (slots().length < max ? makeSlot() : null);
        pendingSlot = null;
        if (!slot) { showErr('Your selected reel includes ' + max + ' photos.'); return; }
        fillSlot(slot, file);
      });
    }

    function bindSlot(slot) {
      slot.addEventListener('click', function () {
        if (isFilled(slot)) return;
        pendingSlot = slot;
        input.click();
      });
    }

    slots().forEach(bindSlot);
    if (moreBtn) moreBtn.addEventListener('click', function () { pendingSlot = makeSlot(); input.click(); });
    input.addEventListener('change', function () {
      if (input.files && input.files.length) handleFiles(input.files);
      input.value = '';
    });

    // re-evaluate the cap when the reel selection changes (product page)
    if (form) {
      var picker = form.querySelector('[data-variant-picker]');
      if (picker) picker.addEventListener('change', function () {
        var max = maxPhotos();
        slots().forEach(function (s, idx) {
          if (idx >= baseSlots && idx >= max && !isFilled(s)) s.remove();
        });
        if (doneCount() > max) showErr('Your selected reel includes ' + max + ' photos — remove ' + (doneCount() - max) + '.');
        else showErr('');
        syncState();
      });
    }

    syncState();
    // After syncState so the adopted photos are counted, and only when this block can actually
    // hold uploads: an unconfigured block is decorative and must not claim to have received them.
    if (configured) adoptFirstLook();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-er-upload]').forEach(initUpload);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
